import React, { useMemo } from 'react';
import DayPicker from 'react-day-picker';
import moment from 'moment';
import 'react-day-picker/lib/style.css';
import styled, {css} from 'styled-components/macro';
// components
import Header from '../../common/Select/Header';
import SelectedItemsSummery from '../../common/Select/SelectedItemsSummery';
import { SelectContainer } from '../../common/Select/SelectStyles';
// utils
import { mobile } from '../../../utils/css/media';
import { ListItem } from '../../common/useFilters';
import {
  colorPink,
  listItemHover,
  colorWhite,
  selectListShadow,
} from '../../../utils/css/colors';
import {
  selectHeaderHeight,
  inputBorderRadius,
} from '../../../utils/css/sizes';
import calendar from '../../../assets/icons/calendar.svg';
import { useTranslation } from 'react-i18next';
import useDetectClickOutside from '../../common/useDetectClickOutside';
import { DISABLED_DAYS } from '../../../utils/constants/date';

interface IProps {
  keyName: string;
  title: string;
  list: any[];
  handleDayClick: (day: Date, modifiers: any) => void;
  removeAllSelected: (key: string) => void;
  isFilterActive: boolean;
}
const iconProps = { rotate: 0, src: calendar, alt: 'calendar' };

const DatePicker: React.FC<IProps> = ({
  keyName,
  title,
  list,
  removeAllSelected,
  handleDayClick,
  isFilterActive,
}) => {
  const { isVisible, toggleIsVisible, wrapperRef } = useDetectClickOutside();

  const selectedItems: ListItem[] = useMemo(() => {
    return list.map((item: ListItem) => {
      if (item.selected) {
        return { ...item, title: moment(item.title).format('DD-MM-YYYY') };
      }
      return null;
    });
  }, [list]);
  const { t } = useTranslation();

  const handleRemoveAll = () => removeAllSelected(keyName);

  const dayPickerProps = {
    selectedDays: list.map((item) => new Date(item.title)),
    onDayClick: handleDayClick,
    initialMonth: new Date(2024, 3),
    disabledDays: DISABLED_DAYS,
    canChangeMonth: true,
  };

  return (
    <SelectContainer>
      <div ref={wrapperRef}>
        <Header
          title={t(title)}
          listOpen={isVisible}
          onClick={toggleIsVisible}
          iconProps={iconProps}
          isFilterActive={isFilterActive}
          selectedItemsCount={selectedItems?.length}
        />
        {isVisible && <CustomeDayPicker {...dayPickerProps} />}
      </div>
      <SelectedItemsSummery
        selectedItems={selectedItems}
        title={t(title)}
        handleRemoveAll={handleRemoveAll}
      />
    </SelectContainer>
  );
};

export const CustomeDayPicker = styled(DayPicker)`
  background: ${colorWhite};
  border-radius: ${inputBorderRadius}px;
  box-shadow: ${selectListShadow};
  position: absolute;
  top: ${selectHeaderHeight}rem;
  overflow: hidden;
  z-index: 3;
  font-size: 1.3rem !important;
  .DayPicker-Day {
    &:focus {
      outline: none;
    }
    &:hover:not(.DayPicker-Day--selected) {
      background-color: ${listItemHover} !important;
    }
  }
  .DayPicker-Day--selected {
    background-color: ${colorPink} !important;
  }
  ${mobile(css`
      position: relative;
  `)};

`;

export default DatePicker;
